import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import { getQuerystringParams } from "./miscellaneous";

export const formatDate = (date: Date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month > 9 ? month : `0${month}`}/${year}`;
};

export const formatTime = (date: Date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours > 9 ? hours : `0${hours}`}:${
    minutes > 9 ? minutes : `0${minutes}`
  }`;
};

export const capitalizeFirstLetter = (word: string) =>
  word[0].toUpperCase() + word.substring(1);

export const cpfMask = (cpf: string) =>
  cpf.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

export const cpfMaskedPreview = (cpf: string) => {
  const digits = cpf.replace(/\D/g, "");
  if (digits.length !== 11) return cpf;
  return `${digits.slice(0, 3)}.***.***-${digits.slice(9, 11)}`;
};

export const cnpjMask = (cnpj: string) =>
  cnpj
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");

export const cnpjMaskedPreview = (cnpj: string) => {
  const digits = cnpj.replace(/\D/g, "");
  if (digits.length !== 14) return cnpj;
  return `${digits.slice(0, 3)}.***.***/${digits.slice(8, 12)}-${digits.slice(
    12,
    14
  )}`;
};

export const handleFormatDateAndTime = (dateString: string) => {
  const parsedDate = parse(dateString, "yyyy-MM-dd'T'HH:mm:ssX", new Date());

  const formatDate = format(parsedDate, "dd/MM/yyyy");
  const formatTime = format(parsedDate, "HH:mm");

  return { formatDate, formatTime };
};

export const buildArrayToQueryStringFields = (array: any[], field: string) =>
  array.map((value) => "&" + field + "=" + value).join("");

export const allowNumbersAndSingleCommaOnly = (value: string) =>
  value
    .replace(/[^\d,]|(?<=\d),(?!\d)|^,|,$/g, "")
    .replace(/,/g, (match, index) => {
      return index > value.indexOf(",") ? "" : match;
    });

export const convertNumberToBRL = (value: number) =>
  value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const handleSortQuerystring = (queryString: URLSearchParams) =>
  "?" +
  Array.from(queryString.entries())
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

export const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const breakStringPreserveSpaces = (str: string, maxLength: number) => {
  const words = str.split(" ");
  let lines = [];
  let currentLine = "";

  for (const word of words) {
    if ((currentLine + word).length > maxLength) {
      lines.push(currentLine.trim());
      currentLine = word + " ";
    } else {
      currentLine += word + " ";
    }
  }

  if (currentLine.trim()) {
    lines.push(currentLine.trim());
  }

  return lines;
};

export function clipWithEllipsis(str: string | undefined | null, max = 30) {
  if (!str) return "";
  return str.length > max ? str.slice(0, max) + "…" : str;
}

export function splitGridTemplateColumns(str: string): string[] {
  const result: string[] = [];
  let current = "";
  let depth = 0;
  for (const char of str) {
    if (char === "(") depth++;
    if (char === ")") depth--;
    if (char === " " && depth === 0) {
      if (current) result.push(current);
      current = "";
    } else {
      current += char;
    }
  }
  if (current) result.push(current);
  return result;
}

export function getClearedFilters() {
  const querystring = getQuerystringParams();

  delete querystring.end_date;
  delete querystring.has_goods_receipt;
  delete querystring.has_payable_accounts;
  delete querystring.invoices_search;
  delete querystring.launch_status;
  delete querystring.link_invoices_search;
  delete querystring.link_payment_slips_search;
  delete querystring.members_search;
  delete querystring.modal;
  delete querystring.orgs_search;
  delete querystring.payment_slips_search;
  delete querystring.role;
  delete querystring.search;
  delete querystring.start_date;
  delete querystring.status;
  delete querystring.users_search;
  delete querystring.visibility;

  querystring.period = "all";
  querystring.page = 1;

  return querystring;
}
